import { render, staticRenderFns } from "./PoolDetail.vue?vue&type=template&id=c62143b0&scoped=true&"
import script from "./PoolDetail.vue?vue&type=script&lang=ts&"
export * from "./PoolDetail.vue?vue&type=script&lang=ts&"
import style0 from "./PoolDetail.vue?vue&type=style&index=0&id=c62143b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c62143b0",
  null
  
)

export default component.exports